import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FunctionsIcon(props: IconProps) {
    return <Icon {...props} iconKey={"functions"}/>
}
